import React from 'react';
import FeaturesContainer from './FeaturesContainer';

const ClusterFeatures = props => (
  <FeaturesContainer {...props} source="cluster" />
);

export default ClusterFeatures;
